import styled from 'styled-components';
import { media } from '../../styles/style-utils';

export const FooterWrap = styled.footer`
  background: rgb(10, 10, 10);
  color: white;
  padding: 2rem 0;
`;

export const ContentSection = styled.section`
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-columns: 50% 50%;
  ${media.fromSmall`grid-template-columns: 50% 50%;`}
  ${media.fromMedium`grid-template-columns: 25% 25% 25% 25%;`}
  ${media.fromLarge`grid-template-columns: 20% 20% 20% 20% 20%;`}
  grid-auto-rows: 1fr;

  > div {
    display: block;
    padding: 1rem;
    margin: 1rem;
    min-height: 100px;

    p {
      margin: 1rem 0;
    }

    a {
      color: rgba(255, 255, 255, 0.85);
      text-decoration: none;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/Footer/FooterStyles.js